import ModalLayout from 'components/ModalLayout';
import Text from 'components/Text/Text';
import {
	IScheduleViewContext,
	ScheduleViewContext,
} from '../../../scheduleViewContext/scheduleViewState/scheduleViewContext';
import {
	EditScheduleContext,
	IEditScheduleContext,
} from './editScheduleModalContext/editScheduleModalState/editScheduleModalContext';
import moment from 'moment';
import React, { useContext, useEffect } from 'react';
import { Form } from 'antd';
import PushTypeSelect from './components/PushTypeSelect';
import ScheduleField from './components/ScheduleField';
import BtnBlock from './components/BtnBlock';
import ModalWindows from './components/ModalWindows';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './EditScheduleModal.module.scss';

interface IEditScheduleModal {
	isVisible: boolean;
	onFailureEvent: () => void;
}

const EditScheduleModal: React.FC<IEditScheduleModal> = ({ isVisible, onFailureEvent }) => {
	const { setDataForSubmit, changeTypeOfModalWindow, changeSchedule, resetFields, scheduleID, pushType, schedule } =
		useContext<IEditScheduleContext>(EditScheduleContext);
	const { setIDForEdit } = useContext<IScheduleViewContext>(ScheduleViewContext);

	const [form] = Form.useForm();

	useEffect(() => {
		if (isVisible) {
			form.setFieldsValue({
				pushType,
				schedule: schedule ? moment(schedule) : '',
			});
		}
	}, [pushType, schedule, isVisible]);

	const submit = () => {
		setDataForSubmit({
			id: scheduleID,
			scheduledDate: schedule,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	const handleCloseModal = () => {
		setIDForEdit('');
		resetFields();
		onFailureEvent();
	};

	return (
		<ModalLayout isVisible={isVisible} setIsShowModal={handleCloseModal} data-test="EditScheduleModal">
			<Text
				className={style.title}
				translationNameSpace="form"
				translationKey="editScheduledPushHeading"
				size="xxl"
				weight="bold"
			/>
			<Form
				className={style.form}
				form={form}
				name="basic"
				onFinish={submit}
				onKeyPress={preventDefaultForEnterKey}
				layout="vertical">
				<div className={style.wrapper}>
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="pushHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<div className={style.row}>
							<PushTypeSelect />
							<ScheduleField schedule={schedule} changeSchedule={changeSchedule} />
						</div>
					</div>
					<div className={style.buttonBlock}>
						<BtnBlock />
					</div>
				</div>
			</Form>
			<ModalWindows />
		</ModalLayout>
	);
};

export default React.memo(EditScheduleModal);
